// Confirmed against the live API (HANDOVER_FRONTEND 2.md): Cheque/NetBanking are gone,
// replaced by a "Bank" mode. The Bank field (bankID) is meaningful whenever mode !== "Cash".
//
// Invoice payments allow Card; Expense/Income/Journal/SupplierAdvance/SupplierPayment's
// PaymentType DB column does NOT allow Card (Cash/UPI/Bank only) — use FINANCE_PAYMENT_MODES
// for those forms, not PAYMENT_MODES.
export const PAYMENT_MODES = [
  { value: "Cash", label: "Cash" },
  { value: "Card", label: "Card" },
  { value: "UPI", label: "UPI" },
  { value: "Bank", label: "Bank" },
];

export const FINANCE_PAYMENT_MODES = [
  { value: "Cash", label: "Cash" },
  { value: "UPI", label: "UPI" },
  { value: "Bank", label: "Bank" },
];

export const PURCHASE_PAYMENT_MODES = [...PAYMENT_MODES, { value: "Credit", label: "Credit" }];
